
import { mdiPlayCircle } from '@mdi/js'

export default {
  mdiPlayCircle,
  props: {
    src: {
      type: String,
      default: null
    },
    poster: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isStarted: false
    }
  },
  methods: {
    startVideo () {
      this.$refs.player.play()
      this.isStarted = true
    }
  }
}
